import { Article, CameraAlt, PermContactCalendar, PictureAsPdf, Receipt, Sms } from '@mui/icons-material';
import { Avatar, Box, Typography } from '@mui/material';
import { Colors } from 'src/shared/components/styles/colors';
import { useTranslation } from 'react-i18next';
import { ExportTypeEnum } from 'src/shared/models/enums/exportType.enum';
import { ExportFileResponse } from '../models/exportFileResponse';

type MyExportsFilePresentationProps = {
  exportFileResponse: ExportFileResponse;
};

interface ExportType {
  label: string;
  type: ExportTypeEnum;
  icon: JSX.Element;
  color: string;
}

const exportTypes: ExportType[] = [
  {
    label: `common:exportFileType.${ExportTypeEnum.MemberSnapshot}`,
    type: ExportTypeEnum.MemberSnapshot,
    icon: <CameraAlt />,
    color: Colors.ColorBox.Blue,
  },
  {
    label: `common:exportFileType.${ExportTypeEnum.MemberExport}`,
    type: ExportTypeEnum.MemberExport,
    icon: <Article />,
    color: Colors.ColorBox.Blue,
  },
  {
    label: `common:exportFileType.${ExportTypeEnum.BookKeepingRecordExport}`,
    type: ExportTypeEnum.BookKeepingRecordExport,
    icon: <Receipt />,
    color: Colors.ColorBox.Blue,
  },
  {
    label: `common:exportFileType.${ExportTypeEnum.AddressLabelExport}`,
    type: ExportTypeEnum.AddressLabelExport,
    icon: <PictureAsPdf />,
    color: Colors.ColorBox.Blue,
  },
  {
    label: `common:exportFileType.${ExportTypeEnum.MemberList}`,
    type: ExportTypeEnum.MemberList,
    icon: <PermContactCalendar />,
    color: Colors.ColorBox.Blue,
  },
  {
    label: `common:exportFileType.${ExportTypeEnum.AutogiroMandate}`,
    type: ExportTypeEnum.AutogiroMandate,
    icon: <Article />,
    color: Colors.ColorBox.Blue,
  },
  {
    label: `common:exportFileType.${ExportTypeEnum.depositExport}`,
    type: ExportTypeEnum.depositExport,
    icon: <Article />,
    color: Colors.ColorBox.Blue,
  },
  {
    label: `common:exportFileType.${ExportTypeEnum.SmsBillingReport}`,
    type: ExportTypeEnum.SmsBillingReport,
    icon: <Sms />,
    color: Colors.ColorBox.Blue,
  },
];

const getExportType = (type: ExportTypeEnum): ExportType => {
  return exportTypes.find((item) => item.type === type) || exportTypes[0];
};

export const MyExportsFilePresentation = (props: MyExportsFilePresentationProps) => {
  const { exportFileResponse } = props;
  const { t } = useTranslation(['common']);

  const { label, icon, color, type } = getExportType(exportFileResponse.exportType);

  const getTitle = () => {
    if (type === ExportTypeEnum.BookKeepingRecordExport) {
      return (
        <>
          {t(label)}{' '}
          <Box component='small' sx={{ fontWeight: 100 }}>
            ({exportFileResponse.fileExtension === 'xlsx' ? 'Excel' : 'SIE'})
          </Box>
        </>
      );
    }
    return <>{t(label)}</>;
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Avatar sx={{ mr: 2, bgcolor: color }}>{icon}</Avatar>
      <Box>
        <Typography sx={{ fontWeight: 600, lineHeight: 1.2 }} variant='body1'>
          {getTitle()}
        </Typography>
        {exportFileResponse.recordCount > 0 && (
          <Typography variant='body2'>
            <small>{t('common:statusMessages.recordCount', { count: exportFileResponse.recordCount })}</small>
          </Typography>
        )}
      </Box>
    </Box>
  );
};
